module.exports = __webpack_public_path__ + "img/lupa.3f48914a.png";